import * as Team from "src/state/modules/team";
import { useOutletContext } from "react-router-dom";
import { mapEventsToScheduleData, overlayLiveGames } from "src/utils/map-events";
import { ScheduleListContainer } from "src/components/compounds/ScheduleList/ScheduleListContainer";
import { useGetTeamEventAndSummariesByIDQuery, useGetTeamLiveGamesByIDQuery } from "src/state/modules/api";
import PageLoader1 from "src/components/atoms/PageLoader/PageLoader";

export interface SchedulePageProps {
  team: Team.Team;
}

const SchedulePage = () => {
  const team = useOutletContext<Team.Team>();
  return team ? <ScheduleSection team={team} /> : <PageLoader1 />;
};

// Poll the lightweight live endpoint so in-progress scores/innings stay fresh while the
// schedule is open. skipPollingIfUnfocused avoids polling in background tabs.
const LIVE_POLL_MS = 30000;

export const ScheduleSection = ({ team }: SchedulePageProps) => {
  const { data: events, isLoading: eventsLoading } = useGetTeamEventAndSummariesByIDQuery(team.id);
  const { data: liveGames } = useGetTeamLiveGamesByIDQuery(team.id, {
    pollingInterval: LIVE_POLL_MS,
    skipPollingIfUnfocused: true,
  });

  if (eventsLoading) return <PageLoader1 />;
  if (events === undefined) return <PageLoader1 />;
  const mergedEvents = overlayLiveGames([...events], liveGames ?? []);
  const scheduleData = mapEventsToScheduleData(mergedEvents, team.id);
  return <ScheduleListContainer scheduleData={scheduleData} />;
};

export default SchedulePage;
